module.exports = __webpack_public_path__ + "img/zgdx.9af57df7.png";